module.exports = "./img/d4918132ba2eef4a827ed3bde84e13bb.jpg";